const DEFAULT_DELAY_TIME = 5000;

export async function delay(ms = DEFAULT_DELAY_TIME): Promise<number> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function isIframe(element: Element | null): element is HTMLIFrameElement {
  return element !== null && element.tagName === 'IFRAME';
}
